<template>
  <div class="pa-3 pb-1">
    <div class="contact-register-table-container">
      <table class="contact-register-table" v-if="dataReport.length">
        <thead>
          <tr>
            <th>Nguồn khách hàng</th>
            <th class="total_source">Tổng contact từng nguồn</th>
            <th>Nhóm sản phẩm</th>
            <th>Số lượng contact</th>
          </tr>
        </thead>
        <tbody>
          <tr class="total-row">
            <td>Tổng contact đăng ký</td>
            <td :colspan="3">{{ total }}</td>
          </tr>
        </tbody>
        <tbody
            v-for="(data, key) in dataReport"
            :key="data.id"
            style="width: 100%">
          <tr
            v-for="(item, index) in dataReport[key].groups"
            :key="item.id"
          >
            <td :rowspan="dataReport[key].groups.length" v-if="index == 0">{{ dataReport[key].name }}</td>
            <td :rowspan="dataReport[key].groups.length" v-if="index == 0" class="total_source">{{ dataReport[key].total }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.total }}</td>
          </tr>
        </tbody>
      </table>
      <table class="contact-register-table" v-else>
        <tr>
          <common-no-result/>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>

import { formatPrice } from '@/helpers/utils'

export default {
  props: {
    dataReport: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0
    }
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
  .contact-register-table-container {
    overflow: auto;
  }
  .contact-register-table {
    border-collapse: separate;
    width: 100%;
    overflow: auto;
    border-spacing: 0px;
    tr:hover {
      background-color: #eeeeee;
    }
    td {
      border-bottom: thin solid black;
      border-left: thin solid black;
      font-weight: 300;
      text-align: center;
      font-size: 14px;
      padding: 5px;
      &:last-child {
        border-right: thin solid black;
      }
      &.total_source {
        width: 250px;
      }
    }
    th {
      border-left: thin solid black;
      border-top: thin solid black;
      border-bottom: thin solid black;
      font-size: 17px;
      font-weight: 500;
      text-align: center;
      position: sticky;
      z-index: 3;
      top: 0px;
      background-color: #9E9E9E;
      color: white;
      &:last-child {
        border-right: thin solid black;
      }
      &.total_source {
        width: 250px;
      }
    }
    .total-row {
      td {
        color: #ff5252;
        font-size: 15px;
        font-weight: bold;
      }
    }
  }
</style>
